import { Button, Layout, Result } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PHONE_TEMPLE_BASE_URL, PHONE_TEMPLE_BASE_URL_IMG } from "../config";

const { Header } = Layout;
const NoPage = () => {
  const [logoImg, setLogoImg] = useState(null);
  const siteInfo = useSelector((state) => state.siteInfoStore);
  useEffect(() => {
    if (siteInfo?.info) {
      if (siteInfo?.info?.status) {
        const settings = JSON.parse(siteInfo.info.panel.settings);
        setLogoImg(settings.company_logo);
      }
    }
  }, [siteInfo]);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);

  const backToHome = () => {
    window.location.href = PHONE_TEMPLE_BASE_URL;
  };

  return (
    <>
      <Header style={{ display: "flex", alignItems: "center" }}>
        <div className="demo-logo" style={{ width: "auto", height: "90%" }}>
          {logoImg && (
            <img
              src={`${PHONE_TEMPLE_BASE_URL_IMG}${logoImg}`}
              style={{ width: "auto", height: "100%" }}
              alt="logo"
            />
          )}
        </div>
      </Header>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button onClick={backToHome} type="primary">
            Back To Home (V22.0.0)
          </Button>
        }
      />
    </>
  );
};

export default NoPage;
